<template>
    <div>

        <v-row >
           
            <v-col  class="py-2">
                <datePickerForm
                    label="Fecha"
                    :valueInput="values.date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                    :errorMessages="serverErrors['date']"
                    data-cy="date-input"
                ></datePickerForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Cliente"
                    :loading="loadingClients"
                    :valueInput="values.client_id"
                    :rule="rules.required"
                    :items="serverItems.clients"
                    :errorMessages="serverErrors.client_id"
                    @valueChange="(v) => {values.client_id = v; this.getProjects(v); delete serverErrors.client_id}"
                    data-cy="client_id-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Proyecto"
                    :loading="loadingProjects"
                    :valueInput="values.project_id"
                    :rule="rules.required"
                    :items="serverItems.projects"
                    :errorMessages="serverErrors.project_id"
                    @valueChange="(v) => {values.project_id = v; this.getServices(v, this.values.client_id); delete serverErrors.project_id}"
                    data-cy="project_id-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


       

       
       

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Almacén"
                    :loading="loadingWarehouses"
                    :valueInput="values.warehouse_id"
                    :rule="rules.required"
                    :items="serverItems.warehouses"
                    :errorMessages="serverErrors.warehouse_id"
                    @valueChange="(v) => {values.warehouse_id = v; delete serverErrors.warehouse_id}"
                    data-cy="warehouse_id-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <textAreaForm 
                    @valueChange="(v) => {values.header = v; delete serverErrors.header}" 
                    :valueInput="values.header" 
                    :rule="[]" 
                    label="Encabezado"
                    :errorMessages="serverErrors.header"
                    data-cy="header-input"
                ></textAreaForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textAreaForm 
                    @valueChange="(v) => {values.comments = v; delete serverErrors.comments}" 
                    :valueInput="values.comments" 
                    :rule="[]" 
                    label="Comentarios"
                    :errorMessages="serverErrors.comments"
                    data-cy="comments-input"
                ></textAreaForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textAreaForm 
                    @valueChange="(v) => {values.terms = v; delete serverErrors.terms}" 
                    :valueInput="values.terms" 
                    :rule="rules.required" 
                    label="Condiciones"
                    :errorMessages="serverErrors.terms"
                    data-cy="terms-input"
                ></textAreaForm>
            </v-col>
        </v-row>
        

        <v-row >
           
            <v-col  class="py-2">
                <datePickerForm
                    label="Vigencia"
                    :valueInput="values.validity"
                    :rule="rules.required"
                    @valueChange="(v) => {values.validity = v; delete serverErrors['validity']}"
                    :errorMessages="serverErrors['validity']"
                    data-cy="validity-input"
                ></datePickerForm>
            </v-col>
        </v-row>

     

       

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Divisa"
                    
                    :valueInput="values.foreign_exchange"
                    :rule="rules.required"
                    :items="serverItems.currencies"
                    :errorMessages="serverErrors.foreign_exchange"
                    @valueChange="(v) => {values.foreign_exchange = v; updateAmountsByCurrency(v); delete serverErrors.foreign_exchange}"
                    data-cy="foreign_exchange-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>



        

        <v-row>
            <v-col class="py-2" cols="9" sm="10"  xl="11">
                <autocompleteOneForm
                    label="Servicios"
                    :loading="loadingServices"
                    :valueInput="serviceSelected"
                    :rule="[]"
                    :items="serverItems.services"
                    :returnObject="true"
                    :disabled="disableAddService"
                    @valueChange="(v) => {serviceSelected = v;}"
                    data-cy="productSelected-input"
                ></autocompleteOneForm>
            </v-col>
            <v-col class="py-2">
                <iconButton
                    data-cy="productSelected-input-btn"
                    :props="{
                    color:'primary',
                    icon:'mdi-plus',
                    height:'41',
                    disabled:disableAddService,
                    click: () => {addService();delete serverErrors.services}
                    }"
                ></iconButton>
            </v-col>
        </v-row>

        <!-- table -->
        <v-row>
            <v-col class="py-2">
                <table-items data-cy="table-items" :props="tableProps" @methodHandler="method_handler" :items="values.services">
                    
                    <template v-slot:item.amount="props" >

                        <div class="table-item">
                            <textFieldForm 
                                @valueChange="(v) => {props.item.amount = v; delete serverErrors.services}" 
                                :valueInput="props.item.amount" 
                                :rule="[...rules.amount]" 
                                :disabled="props.item.disabled"
                                data-cy="table-amount-input"
                            ></textFieldForm>
                        </div>
                    </template>

                    <template v-slot:item.quantity="props" >

                        <div class="table-item">
                            <textFieldForm 
                                @valueChange="(v) => {props.item.quantity = v; delete serverErrors.services}" 
                                :valueInput="props.item.quantity" 
                                :rule="[...rules.quantity]" 
                                
                                data-cy="table-quantity-input"
                            ></textFieldForm>
                        </div>
                    </template>
                    
                </table-items>
                
            </v-col>
            
        </v-row>
        <span class="red--text caption" v-if="serverErrors[`services`]">{{serverErrors[`services`]}}</span>
      
      

        
       

    </div>
</template>

<script>

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
   
    data(){
        return {
            disableAddService:true,
            loadingWarehouses: false,
            loadingClients: false,
            loadingServices: false,
            loadingProjects: false,
            serviceSelected: {},
            currenciesBanxio: {cad: 0, usd: 0, eur: 0},
            actions: [
				
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItem',
                    dataCy: "delete-link"
				},
			],
            tableProps: {
				headers: [
                     {
						text: 'Servicio',
						align: 'left break-words',
						value: 'name',
                        
						class: 'table-b-border black--text',
                        sortable: false,
					},
					{
						text: 'P.U.',
						align: 'center',
						value: 'amount',
                        width: "18%",
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cantidad esperada',
						align: 'center',
						value: 'quantity',
                        width: "18%",
						sortable: false,
						class: 'table-b-border black--text'
					},
                    
                   
					{
						text: '',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
                
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,2})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],

                quantity: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],
				
				
            },

            serverItems:{
               
                warehouses: [],
                clients: [],
                services: [],
                projects: [],

                currencies: [
                    {value:"mxn", text:"Peso mexicano (MXN)" },
                    {value:"usd", text:"Dólar estadounidense (USD)" },
                    {value:"eur", text:"Euro (EUR)" },
                    {value:"cad", text:"Dólar canadiense (CAD)" },
                ]

            }
            

          
        }
    },
   
    mounted(){
        this.getWarehouses();
        this.getClients();
        this.getCurrencies();
        if(this.edit){
            this.loadServices();
            this.getProjects(this.values.client_id);
        }
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        loadServices()
        {
            this.values.services = this.values.services.map((item,i) => {
                // x['parameters'] = { id: x.slug, name: x.sku, index: i};
                
              
               
                let newServic = {
                    actions: JSON.parse(JSON.stringify(this.actions)),
                    parameters: { id: item.service_id, name: item.service, index: 99},
                    service_id: item.service_id,
                    name: item.service,
                    quantity : item.quantity,
                    foreign_exchange: item.foreign_exchange??this.values.foreign_exchange,
                    amount: item.amount+"".replace(",",""),
                    disabled:true,
                }
                newServic.actions[0].disabled = true;
                return newServic;
            })
        },
        getCurrencies()
        {
            this.$api.banxioSIE.getCurrencyDataMXN()
                .then((resp) => {
                    console.log(resp.data);
                   
                    this.currenciesBanxio = this.$api.banxioSIE.processInformation(resp.data);
                    console.log(this.currenciesBanxio);
                })
                .catch((error) => {
                    this.currenciesBanxio = {cad: 0, usd: 0, eur: 0};
                })
                .finally(() => {
                    
                })
            ;
        },
        getWarehouses()
        {
            // this.loadingWarehouses = true;
            // this.$api.warehouse.getSelect()
            //     .then((resp) => {
            //         this.serverItems.warehouses = resp.data;
            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     })
            //     .finally(() => {
            //         this.loadingWarehouses = false;
            //     })
            // ;
            this.serverItems.warehouses = this.$store.state.userData.warehousesRaw.map((x) => {
                return {value: x.slug, text:x.name}
            });
        },
        getClients()
        {
            this.loadingClients = true;
            this.$api.client.getSelect(this.$store.state.warehouse)
                .then((resp) => {
                    //hacer map
                    this.serverItems.clients = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingClients = false;
                })
            ;
        },

        updateAmountsByCurrency(to)
        {
            for (let i = 0; i < this.values.services.length; i++) {
                this.values.services[i].amount = this.$api.banxioSIE.convertCurrencyTo(this.currenciesBanxio, this.values.services[i].foreign_exchange, to, this.values.services[i].amount)
                this.values.services[i].foreign_exchange = to;
            }
        },

        getProjects(client_id)
        {
            if(client_id == null || client_id == undefined || client_id == "")
                return;

            this.loadingProjects = true;
            this.$api.client.getProjectsSelect(client_id, this.$store.state.warehouse)
                .then((resp) => {
                    //hacer map
                    this.serverItems.projects = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingProjects = false;
                })
            ;


        },


        addService()
        {
            console.log(this.serviceSelected);

            if(!("value" in this.serviceSelected))
                return;

            let found = this.values.services.find(fItem => fItem.service_id == this.serviceSelected.value)
            if(found != undefined)
                return;

            let item = this.serviceSelected;
            let newServic = {
                actions: JSON.parse(JSON.stringify(this.actions)),
                parameters: { id: item.value, name: item.text, index: 99},
                service_id: item.value,
                foreign_exchange: item.foreign_exchange??this.values.foreign_exchange,
                name: item.text,
                quantity : 1,
                amount: item.price,
                disabled:false,
            }

            this.values.services.push(newServic);

            
        },

       

        getServices(project_id, client_id)
        {
            this.values.services = [];
           
            if(project_id == "" || project_id == null || project_id == undefined)
                return;
            if(client_id == "" || client_id == null || client_id == undefined)
                return;

            this.loadingServices = true;
            this.$api.service.byClientProject(client_id,project_id)
                .then((resp) => {
                    // this.serverItems.services = resp.data.services;

                    if(resp.data.data == null){
                        this.serverItems.services = resp.data.services;
                        this.disableAddService = false;
                        return;
                    }
                    //set data
                    this.values.comments = resp.data.data.comments;
                    this.values.foreign_exchange = resp.data.data.foreign_exchange;
                    this.values.terms = resp.data.data.terms;
                    this.values.validity = resp.data.data.validity;
                    this.values.warehouse_id = resp.data.data.warehouse;
                    //set services
                    resp.data.services.forEach(item => {
                        let newServic = {
                            actions: JSON.parse(JSON.stringify(this.actions)),
                            parameters: { id: item.value, name: item.text, index: 99},
                            service_id: item.value,
                            name: item.text,
                            quantity : item.quantity,
                            foreign_exchange: resp.data.data.foreign_exchange,
                            // amount: item.price+"".replace(",",""),
                            amount: this.$api.banxioSIE.convertCurrencyTo(this.currenciesBanxio, item.foreign_exchange, this.values.foreign_exchange, item.price+"".replace(",","")),
                            disabled:true,
                        }
                        newServic.actions[0].disabled = true;

                        this.values.services.push(newServic);
                    });
                    delete this.serverErrors.services;
                    this.disableAddService = true;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingServices = false;
                })
            ;
        },

        deleteItem(item)
        {
            let index = this.values.services.findIndex(prod => prod.service_id == item.id);

            console.log(index, item);
            this.values.services.splice(index, 1);
        }
       
    }
}
</script>

<style>

</style>